import { Button, Drawer, Form, Input, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const MerchantSavePOUnsave = ({
  originalTab,
  open,
  close,
  setLoading,
  getPOUnsaveList,
  getPOSaveList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);

  const handleSaveToPO = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/save-po-unsave", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Saved to PO successfully.");
          setTimeout(() => {
            originalTab();
            close();
            setLoadings(false);
            setLoading(false);
            getPOUnsaveList();
            getPOSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Save Prepared Purchase Order"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="save-po"
        initialValues={{ remember: true }}
        onFinish={handleSaveToPO}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="po_number"
            label="PO Number"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set PO" size="large" />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default MerchantSavePOUnsave;
